(function($) {
	'use strict';


	/**
	 * Spinner object
	 * @param {string|DOMElement} element
	 */
	var Spinner = function(element) {
		this.$element = $(element);
		this.className = 'spinning';
		this.status = 'off';
		this.timer;
		this.node = '<spinner><wheel><svg viewBox="0 0 50 50">'
			+ '<circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>'
			+ '</svg></wheel></spinner>';
	};


	/**
	 * @public
	 * @param   {integer} delay count of miliseconds
	 * @returns {this}
	 */
	Spinner.prototype.start = function(delay) {
		var spinner = this;

		if (delay !== undefined && this.timer === undefined) {
			this.timer = setTimeout(function() {spinner._add();},delay);
		}

		if (delay === undefined) {
			spinner._add();
		}

		return this;
	};


	/**
	 * @public
	 * @returns {this}
	 */
	Spinner.prototype.stop = function() {
		clearTimeout(this.timer);
		this.timer = undefined;

		if (this.status === 'on') {
			this.$element.removeClass(this.className);
			this.$element.find('spinner').remove();
			this.status = 'off';
		}

		return this;
	};


	Spinner.prototype._add = function() {
		clearTimeout(this.timer);
		this.timer = undefined;

		if (this.status === 'off') {
			this.status = 'on';
			this.$element.addClass(this.className).append(this.node);
		}
	};


	/**
	 * Spinner plugin
	 * @param   {string} option [start, stop]
	 * @returns {this}
	 */
	$.fn.spinner = function(option) {
		if (option === 'start') {
			this.each(function() {
				if (!(this.spinner instanceof Spinner)) {
					this.spinner = new Spinner(this);
				}
				this.spinner.start();
			});
		}

		if (option === 'stop') {
			this.each(function() {
				if (!(this.spinner instanceof Spinner)) {
					this.spinner = new Spinner(this);
				}
				this.spinner.stop();
			});
		}

		return this;
	};


	/**
	 * @pulic
	 * @param   {string|DOMElement} element
	 * @returns {Spinner}
	 */
	$.createSpinner = function(element) {
		return new Spinner(element);
	};


	$.spinner = new Spinner('body');

}(jQuery));